import React from "react";
import "./App.css";
import { Link } from "react-router-dom";
//import About from '/images/about.png'

const App = () => {
  return (
    <section className="hero_section">
      <div className="card_grid">
        <Link to="/about" className="card">
          <img src="/images/about.png" className="card_background" />
          <div className="card_content">
            <p className="card_category">About</p>
            <h3 className="card_heading">Who am I ?</h3>
          </div>
        </Link>
        <Link to="/tech" className="card">
          <img src="/images/tech.png" className="card_background" />
          <div className="card_content">
            <p className="card_category">Tech stack</p>
            <h3 className="card_heading">Technologies I used</h3>
          </div>
        </Link>
        <Link to="/training" className="card">
          <img src="/images/training.jpg" className="card_background" />
          <div className="card_content">
            <p className="card_category">Training</p>
            <h3 className="card_heading">Courses Trainings Goals</h3>
          </div>
        </Link>
        <Link to="/projects" className="card">
          <img src="/images/project.png" className="card_background" />
          <div className="card_content">
            <p className="card_category">Projects</p>
            <h3 className="card_heading">Apps I developed</h3>
          </div>
        </Link>
      </div>
    </section>
  );
};

export default App;
